<template>
    <ContainerWithMenu>
        <div class="page-content">
            <div class="row margin-bottom-20">
                <div class="col-xs-12 col-md-7">
                    <h1 class="h2 margin-0">{{ $t('views.subscriptions_type.title') }}</h1>
                </div>
                <div class="col-xs-12 col-md-5 text-right">
                    <button
                            class="btn btn-primary btn-action-mobile"
                            @click="showAddSubscriptionModal"
                    >
                        <i class="las la-plus"></i>
                        <span class="button-text">{{ $t('views.subscriptions_type.new') }}</span>
                    </button>
                </div>
            </div>
            <Pagination
                    v-show="numberPagesSubscriptionsType > 1"
                    :page-count="numberPagesSubscriptionsType"
                    :click-handler="paginateCallback" />
            <div class="table-responsive" v-if="subscriptionsType.length > 0">
                <SubscriptionTypeTable :subscriptionsTypes="subscriptionsType"
                                       @show-subscribers-active="showSubscribersActive"></SubscriptionTypeTable>
            </div>
            <div v-else>
                <span class="text-muted"> {{ $t('views.subscriptions_type.not_found') }} </span>
            </div>
        </div>
        <AddSubscriptionTypeModal v-show="addSubscriptionTypeModalVisible" :visible="addSubscriptionTypeModalVisible" @close-subscription-type-modal="addSubscriptionTypeModalVisible=false"></AddSubscriptionTypeModal>
        <ActiveSubscriptionsModal v-show="subscriptionsActiveModalVisible" :visible="subscriptionsActiveModalVisible" @close-active-subscriptions="subscriptionsActiveModalVisible=false" :subscription-type-id="selectedSubscriptionType"></ActiveSubscriptionsModal>
        <SpinnerLoader v-show="loading"></SpinnerLoader>
    </ContainerWithMenu>
</template>

<script>
    import ContainerWithMenu from "../components/container/ContainerWithMenu";
    import SpinnerLoader from "../components/common/SpinnerLoader";
    import {LIMIT_RECORDS_API} from "../common/constants";
    import {Utils} from "../common/utils";
    import {getSubscriptionsType} from "../api";
    import SubscriptionTypeTable from "../components/subscription_type/SubscriptionTypeTable";
    import AddSubscriptionTypeModal from "../components/modal/AddSubscriptionTypeModal";
    import Pagination from "../components/common/Pagination";
    import ActiveSubscriptionsModal from "@/components/modal/ActiveSubscriptionsModal";

    export default {
        title: "Abbonamenti & Carnet",
        name: "SubscriptionsType",
        components: { ContainerWithMenu, SpinnerLoader, Pagination, SubscriptionTypeTable, AddSubscriptionTypeModal, ActiveSubscriptionsModal },
        data: () => {
            return {
                subscriptionsType: [],
                countSubscriptionsType: 0,
                limitSubscriptionsType: LIMIT_RECORDS_API,
                currentPageSubscription: 1,
                loading: false,
                addSubscriptionTypeModalVisible: false,
                subscriptionsActiveModalVisible: false,
                selectedSubscriptionType: -1
            }
        },
        methods: {
            showSubscribersActive(subscriptionTypeId) {
                this.selectedSubscriptionType = subscriptionTypeId
                this.subscriptionsActiveModalVisible = true
            },
            async getSubscriptionsType(page = 1) {
                this.loading = true;
                try {
                    let subscriptionsTypeResponse = await getSubscriptionsType(page);
                    this.countSubscriptionsType = subscriptionsTypeResponse.count;

                    this.saveSubscriptionsWithSeparator(subscriptionsTypeResponse);
                    this.loading = false;
                } catch (e) {
                    this.loading = false;
                    console.log(e)
                }
            },
            saveSubscriptionsWithSeparator(subscriptionsTypeResponse) {
                const subscriptionsType = subscriptionsTypeResponse.results;
                let subscriptionsTypeWithSeparators = [];
                for (let i = 0; i < subscriptionsType.length; i++) {
                    if (i === 0) {
                        subscriptionsTypeWithSeparators.push({ separator: true, separator_name: Utils.getStringSubscriptionCategory(subscriptionsType[i].category).toUpperCase()});
                    } else if (subscriptionsType[i].category !== subscriptionsType[i-1].category) {
                        subscriptionsTypeWithSeparators.push({ separator: true, separator_name: Utils.getStringSubscriptionCategory(subscriptionsType[i].category).toUpperCase()});
                    }
                    subscriptionsTypeWithSeparators.push(subscriptionsType[i])

                }
                this.subscriptionsType = subscriptionsTypeWithSeparators;
            },
            showAddSubscriptionModal() {
                this.addSubscriptionTypeModalVisible = true;
            },
            paginateCallback(pageNum) {
                this.getSubscriptionsType(pageNum)
            },
        },
        computed: {
            numberPagesSubscriptionsType: function () {
                return Utils.getNumberPageByCountLimit(this.countSubscriptionsType, this.limitSubscriptionsType);

            }
        },
        mounted() {
            this.getSubscriptionsType()
        }
    };
</script>
